export { PillControl } from './src/pill-control';
